import { DownloadsActions } from './actions'
import { DownloadsGetters } from './getters'
import { DownloadsMutations } from './mutations'
import { DownloadsState } from './state'

export const DOWNLOADS_NAMESPACE = 'downloads'

export const Downloads = {
  namespaced: true,
  state: DownloadsState,
  actions: DownloadsActions,
  mutations: DownloadsMutations,
  getters: DownloadsGetters,
}
